import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Font, Fonts} from '@shared/controls/signature-pad/font-list';

@Component({
  selector: 'pl-signature-font-selector',
  templateUrl: 'signature-font-selector.component.html',
  styleUrls: ['./signature-font-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SignatureFontSelectorComponent),
      multi: true
    }
  ]
})
export class SignatureFontSelectorComponent implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  Fonts = Fonts;

  @Input() disabled: boolean;
  @Input() signatureText: string;

  private _value = Fonts[0].id;
  @Input() set value(v: string) {
    this.writeValue(v);
  }
  get value(): string {
    return this._value;
  }

  get font(): Font {
    return Fonts.find(f => f.id === this.value);
  }

  onChange = (value: string) => {};
  onTouched = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value: string): void {
    this._value = value ?? '';
    this.cdr.detectChanges();
  }

  changeValue(value: string): void {
    if (this.disabled) {
      return;
    }

    const valueChanged = value !== this.value;

    if (valueChanged) {
      this.writeValue(value);
      this.onChange(value);
    }

    this.onTouched();
  }
}
